export default "__VITE_ASSET__c7f0c76f__"